var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "#FF0051",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12 22C17.511 22 22 17.511 22 12C22 6.489 17.511 2 12 2C6.489 2 2 6.48899 2 12C2 17.511 6.489 22 12 22ZM12 20C7.56988 20 4 16.4301 4 12C4 7.56988 7.56988 4 12 4C16.4301 4 20 7.56988 20 12C20 16.4301 16.4301 20 12 20Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.24 13.706H13.172C13.172 12.474 15.524 11.858 15.524 9.758C15.524 7.952 13.97 7 12.388 7C10.904 7 9.574 7.756 9 9.17L10.652 10.122C10.946 9.366 11.492 8.876 12.318 8.876C13.13 8.876 13.592 9.254 13.592 9.898C13.592 11.284 11.24 11.858 11.24 13.706ZM12.206 17.178C12.864 17.178 13.396 16.646 13.396 15.988C13.396 15.33 12.864 14.798 12.206 14.798C11.548 14.798 11.016 15.33 11.016 15.988C11.016 16.646 11.548 17.178 12.206 17.178Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgQuestion, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/question.364fb170.svg";
export { ForwardRef as ReactComponent };